<!-- 步骤图标组件 -->
<style lang="scss" scoped>
.step-icon {
  font-size: 24px;

  .step-box {
    background: #f2f2f2;
    padding: 0 6px;
  }

  .process,
  .default,
  .error {
    width: 24px;
    height: 24px;
    background: #d9d9d9;
    border-radius: 50%;
  }

  .finish {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: 1px solid #002fbe;
    background: #ffffff;
    border-radius: 50%;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
</style>

<template>
  <div class="step-icon">
    <!-- 签约中 -->
    <div v-if="activeStep === step && stepStatus !== JOIN_STATUS.SUCCESS" class="step-box">
      <div class="process" />
    </div>
    <!-- 失败 暂时未用上-->
    <!-- <div v-else-if="activeStep === step && stepStatus !== JOIN_STATUS.SUCCESS" class="error" /> -->
    <!-- 成功 -->
    <div v-else-if="(activeStep === step && stepStatus === JOIN_STATUS.SUCCESS) || activeStep > step" class="step-box">
      <div class="finish">
        <img :src="checkIcon" alt="finish" />
      </div>
    </div>
    <div v-else class="step-box">
      <div class="default" />
    </div>
  </div>
</template>

<script setup>
import checkIcon from '@/assets/image/p-check.png'
import { JOIN_STATUS } from './data'

defineOptions({
  name: 'step-icon',
})

defineProps({
  // 当前步骤
  step: {
    type: Number,
    default: 0,
  },
  // 激活到哪个步骤
  activeStep: {
    type: Number,
    default: 0,
  },
  // 状态
  stepStatus: {
    type: Number,
    default: JOIN_STATUS.WAIT_SUBMIT, // 默认待提交
  },
})
</script>
